import { categoryNameToHandle } from '@lambda/reebelo/src/commonHelpers';
import Section from '@/components/commons/Section';
import DesktopView from '@/components/commons/PopularCategories/DesktopView';
import MobileView from '@/components/commons/PopularCategories/MobileView';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import { SubCategoryDataT } from '../types';
import settings from '@/settings';
import { PopularCategory } from '@/settings/popular-categories/types';

const CategoriesGrid = ({
  handle,
  subCategories,
  title,
}: {
  handle: string;
  subCategories: SubCategoryDataT[];
  title: string;
}) => {
  const categories = subCategories.map((subCategory) => {
    const categoryName =
      subCategory.storeConfig?.[settings.store]?.title ??
      subCategory.config.title;

    const categoryHandle = categoryNameToHandle(categoryName);

    const streamLinedCategory: PopularCategory = {
      pk: subCategory.pk,
      title: categoryName,
      imageUrl: getEdgeUrl(
        `images/collections/category/top-categories/${handle}/${categoryHandle}.png`,
      ),
    };

    if (subCategory.offerCount === 0) streamLinedCategory.badge = 'Soon';

    return streamLinedCategory;
  });

  return (
    <Section className="reebelo-container py-8">
      <div>
        <h2 className="flex items-center text-lg font-semibold md:text-xl">
          Top {title} Categories
        </h2>
        <DesktopView categories={categories} />
        <MobileView categories={categories} key={handle} />
      </div>
    </Section>
  );
};

export default CategoriesGrid;
